import { render, staticRenderFns } from "./ProductImages.vue?vue&type=template&id=7091e421&scoped=true"
import script from "./ProductImages.vue?vue&type=script&lang=js"
export * from "./ProductImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7091e421",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7091e421')) {
      api.createRecord('7091e421', component.options)
    } else {
      api.reload('7091e421', component.options)
    }
    module.hot.accept("./ProductImages.vue?vue&type=template&id=7091e421&scoped=true", function () {
      api.rerender('7091e421', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/ProductImages.vue"
export default component.exports